export const mediaManifest = {
  "IMG_0129.JPG": {
    "width": 6000,
    "height": 4000,
    "sources": {
      "avif": [
        "/media/vtd/img_0129-480.avif 480w",
        "/media/vtd/img_0129-960.avif 960w",
        "/media/vtd/img_0129-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/img_0129-480.webp 480w",
        "/media/vtd/img_0129-960.webp 960w",
        "/media/vtd/img_0129-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/img_0129-480.jpg 480w",
        "/media/vtd/img_0129-960.jpg 960w",
        "/media/vtd/img_0129-1600.jpg 1600w"
      ]
    }
  },
  "IMG_0809.JPG": {
    "width": 6000,
    "height": 4000,
    "sources": {
      "avif": [
        "/media/vtd/img_0809-480.avif 480w",
        "/media/vtd/img_0809-960.avif 960w",
        "/media/vtd/img_0809-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/img_0809-480.webp 480w",
        "/media/vtd/img_0809-960.webp 960w",
        "/media/vtd/img_0809-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/img_0809-480.jpg 480w",
        "/media/vtd/img_0809-960.jpg 960w",
        "/media/vtd/img_0809-1600.jpg 1600w"
      ]
    }
  },
  "IMG_3086.JPG": {
    "width": 6000,
    "height": 4000,
    "sources": {
      "avif": [
        "/media/vtd/img_3086-480.avif 480w",
        "/media/vtd/img_3086-960.avif 960w",
        "/media/vtd/img_3086-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/img_3086-480.webp 480w",
        "/media/vtd/img_3086-960.webp 960w",
        "/media/vtd/img_3086-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/img_3086-480.jpg 480w",
        "/media/vtd/img_3086-960.jpg 960w",
        "/media/vtd/img_3086-1600.jpg 1600w"
      ]
    }
  },
  "IMG_7075.JPG": {
    "width": 6000,
    "height": 4000,
    "sources": {
      "avif": [
        "/media/vtd/img_7075-480.avif 480w",
        "/media/vtd/img_7075-960.avif 960w",
        "/media/vtd/img_7075-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/img_7075-480.webp 480w",
        "/media/vtd/img_7075-960.webp 960w",
        "/media/vtd/img_7075-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/img_7075-480.jpg 480w",
        "/media/vtd/img_7075-960.jpg 960w",
        "/media/vtd/img_7075-1600.jpg 1600w"
      ]
    }
  },
  "city-tram-custom-2026.jpg": {
    "width": 960,
    "height": 600,
    "sources": {
      "avif": [
        "/media/vtd/city-tram-custom-2026-480.avif 480w",
        "/media/vtd/city-tram-custom-2026-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/city-tram-custom-2026-480.webp 480w",
        "/media/vtd/city-tram-custom-2026-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/city-tram-custom-2026-480.jpg 480w",
        "/media/vtd/city-tram-custom-2026-960.jpg 960w"
      ]
    }
  },
  "city-tram-custom.jpg": {
    "width": 2400,
    "height": 1800,
    "sources": {
      "avif": [
        "/media/vtd/city-tram-custom-480.avif 480w",
        "/media/vtd/city-tram-custom-960.avif 960w",
        "/media/vtd/city-tram-custom-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/city-tram-custom-480.webp 480w",
        "/media/vtd/city-tram-custom-960.webp 960w",
        "/media/vtd/city-tram-custom-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/city-tram-custom-480.jpg 480w",
        "/media/vtd/city-tram-custom-960.jpg 960w",
        "/media/vtd/city-tram-custom-1600.jpg 1600w"
      ]
    }
  },
  "city-tram-globe-2026.jpg": {
    "width": 1280,
    "height": 960,
    "sources": {
      "avif": [
        "/media/vtd/city-tram-globe-2026-480.avif 480w",
        "/media/vtd/city-tram-globe-2026-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/city-tram-globe-2026-480.webp 480w",
        "/media/vtd/city-tram-globe-2026-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/city-tram-globe-2026-480.jpg 480w",
        "/media/vtd/city-tram-globe-2026-960.jpg 960w"
      ]
    }
  },
  "city-tram.jpg": {
    "width": 2400,
    "height": 1800,
    "sources": {
      "avif": [
        "/media/vtd/city-tram-480.avif 480w",
        "/media/vtd/city-tram-960.avif 960w",
        "/media/vtd/city-tram-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/city-tram-480.webp 480w",
        "/media/vtd/city-tram-960.webp 960w",
        "/media/vtd/city-tram-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/city-tram-480.jpg 480w",
        "/media/vtd/city-tram-960.jpg 960w",
        "/media/vtd/city-tram-1600.jpg 1600w"
      ]
    }
  },
  "photo_2025-03-10_12-58-30.jpg": {
    "width": 1280,
    "height": 960,
    "sources": {
      "avif": [
        "/media/vtd/photo_2025-03-10_12-58-30-480.avif 480w",
        "/media/vtd/photo_2025-03-10_12-58-30-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/photo_2025-03-10_12-58-30-480.webp 480w",
        "/media/vtd/photo_2025-03-10_12-58-30-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/photo_2025-03-10_12-58-30-480.jpg 480w",
        "/media/vtd/photo_2025-03-10_12-58-30-960.jpg 960w"
      ]
    }
  },
  "photo_2025-03-10_12-58-41.jpg": {
    "width": 1280,
    "height": 960,
    "sources": {
      "avif": [
        "/media/vtd/photo_2025-03-10_12-58-41-480.avif 480w",
        "/media/vtd/photo_2025-03-10_12-58-41-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/photo_2025-03-10_12-58-41-480.webp 480w",
        "/media/vtd/photo_2025-03-10_12-58-41-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/photo_2025-03-10_12-58-41-480.jpg 480w",
        "/media/vtd/photo_2025-03-10_12-58-41-960.jpg 960w"
      ]
    }
  },
  "photo_2025-03-10_12-59-13.jpg": {
    "width": 1280,
    "height": 960,
    "sources": {
      "avif": [
        "/media/vtd/photo_2025-03-10_12-59-13-480.avif 480w",
        "/media/vtd/photo_2025-03-10_12-59-13-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/photo_2025-03-10_12-59-13-480.webp 480w",
        "/media/vtd/photo_2025-03-10_12-59-13-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/photo_2025-03-10_12-59-13-480.jpg 480w",
        "/media/vtd/photo_2025-03-10_12-59-13-960.jpg 960w"
      ]
    }
  },
  "photo_2025-03-10_12-59-47.jpg": {
    "width": 960,
    "height": 1280,
    "sources": {
      "avif": [
        "/media/vtd/photo_2025-03-10_12-59-47-480.avif 480w",
        "/media/vtd/photo_2025-03-10_12-59-47-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/photo_2025-03-10_12-59-47-480.webp 480w",
        "/media/vtd/photo_2025-03-10_12-59-47-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/photo_2025-03-10_12-59-47-480.jpg 480w",
        "/media/vtd/photo_2025-03-10_12-59-47-960.jpg 960w"
      ]
    }
  },
  "photo_2025-03-10_13-00-09.jpg": {
    "width": 1280,
    "height": 960,
    "sources": {
      "avif": [
        "/media/vtd/photo_2025-03-10_13-00-09-480.avif 480w",
        "/media/vtd/photo_2025-03-10_13-00-09-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/photo_2025-03-10_13-00-09-480.webp 480w",
        "/media/vtd/photo_2025-03-10_13-00-09-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/photo_2025-03-10_13-00-09-480.jpg 480w",
        "/media/vtd/photo_2025-03-10_13-00-09-960.jpg 960w"
      ]
    }
  },
  "photo_2025-03-10_13-00-19.jpg": {
    "width": 960,
    "height": 1280,
    "sources": {
      "avif": [
        "/media/vtd/photo_2025-03-10_13-00-19-480.avif 480w",
        "/media/vtd/photo_2025-03-10_13-00-19-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/photo_2025-03-10_13-00-19-480.webp 480w",
        "/media/vtd/photo_2025-03-10_13-00-19-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/photo_2025-03-10_13-00-19-480.jpg 480w",
        "/media/vtd/photo_2025-03-10_13-00-19-960.jpg 960w"
      ]
    }
  },
  "photo_2025-03-10_13-00-24.jpg": {
    "width": 1280,
    "height": 960,
    "sources": {
      "avif": [
        "/media/vtd/photo_2025-03-10_13-00-24-480.avif 480w",
        "/media/vtd/photo_2025-03-10_13-00-24-960.avif 960w"
      ],
      "webp": [
        "/media/vtd/photo_2025-03-10_13-00-24-480.webp 480w",
        "/media/vtd/photo_2025-03-10_13-00-24-960.webp 960w"
      ],
      "jpeg": [
        "/media/vtd/photo_2025-03-10_13-00-24-480.jpg 480w",
        "/media/vtd/photo_2025-03-10_13-00-24-960.jpg 960w"
      ]
    }
  },
  "tb1-9659.jpg": {
    "width": 2400,
    "height": 1600,
    "sources": {
      "avif": [
        "/media/vtd/tb1-9659-480.avif 480w",
        "/media/vtd/tb1-9659-960.avif 960w",
        "/media/vtd/tb1-9659-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/tb1-9659-480.webp 480w",
        "/media/vtd/tb1-9659-960.webp 960w",
        "/media/vtd/tb1-9659-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/tb1-9659-480.jpg 480w",
        "/media/vtd/tb1-9659-960.jpg 960w",
        "/media/vtd/tb1-9659-1600.jpg 1600w"
      ]
    }
  },
  "tram-bears-6084.jpg": {
    "width": 2400,
    "height": 1800,
    "sources": {
      "avif": [
        "/media/vtd/tram-bears-6084-480.avif 480w",
        "/media/vtd/tram-bears-6084-960.avif 960w",
        "/media/vtd/tram-bears-6084-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/tram-bears-6084-480.webp 480w",
        "/media/vtd/tram-bears-6084-960.webp 960w",
        "/media/vtd/tram-bears-6084-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/tram-bears-6084-480.jpg 480w",
        "/media/vtd/tram-bears-6084-960.jpg 960w",
        "/media/vtd/tram-bears-6084-1600.jpg 1600w"
      ]
    }
  },
  "trolleybus-depot.jpg": {
    "width": 2400,
    "height": 1800,
    "sources": {
      "avif": [
        "/media/vtd/trolleybus-depot-480.avif 480w",
        "/media/vtd/trolleybus-depot-960.avif 960w",
        "/media/vtd/trolleybus-depot-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/trolleybus-depot-480.webp 480w",
        "/media/vtd/trolleybus-depot-960.webp 960w",
        "/media/vtd/trolleybus-depot-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/trolleybus-depot-480.jpg 480w",
        "/media/vtd/trolleybus-depot-960.jpg 960w",
        "/media/vtd/trolleybus-depot-1600.jpg 1600w"
      ]
    }
  },
  "trolleybus-inside.jpg": {
    "width": 2400,
    "height": 3200,
    "sources": {
      "avif": [
        "/media/vtd/trolleybus-inside-480.avif 480w",
        "/media/vtd/trolleybus-inside-960.avif 960w",
        "/media/vtd/trolleybus-inside-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/trolleybus-inside-480.webp 480w",
        "/media/vtd/trolleybus-inside-960.webp 960w",
        "/media/vtd/trolleybus-inside-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/trolleybus-inside-480.jpg 480w",
        "/media/vtd/trolleybus-inside-960.jpg 960w",
        "/media/vtd/trolleybus-inside-1600.jpg 1600w"
      ]
    }
  },
  "vtd-group.jpg": {
    "width": 2400,
    "height": 1800,
    "sources": {
      "avif": [
        "/media/vtd/vtd-group-480.avif 480w",
        "/media/vtd/vtd-group-960.avif 960w",
        "/media/vtd/vtd-group-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/vtd-group-480.webp 480w",
        "/media/vtd/vtd-group-960.webp 960w",
        "/media/vtd/vtd-group-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/vtd-group-480.jpg 480w",
        "/media/vtd/vtd-group-960.jpg 960w",
        "/media/vtd/vtd-group-1600.jpg 1600w"
      ]
    }
  },
  "ztd-0077.jpg": {
    "width": 2400,
    "height": 1600,
    "sources": {
      "avif": [
        "/media/vtd/ztd-0077-480.avif 480w",
        "/media/vtd/ztd-0077-960.avif 960w",
        "/media/vtd/ztd-0077-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/ztd-0077-480.webp 480w",
        "/media/vtd/ztd-0077-960.webp 960w",
        "/media/vtd/ztd-0077-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/ztd-0077-480.jpg 480w",
        "/media/vtd/ztd-0077-960.jpg 960w",
        "/media/vtd/ztd-0077-1600.jpg 1600w"
      ]
    }
  },
  "ztd-0292.jpg": {
    "width": 2400,
    "height": 1600,
    "sources": {
      "avif": [
        "/media/vtd/ztd-0292-480.avif 480w",
        "/media/vtd/ztd-0292-960.avif 960w",
        "/media/vtd/ztd-0292-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/ztd-0292-480.webp 480w",
        "/media/vtd/ztd-0292-960.webp 960w",
        "/media/vtd/ztd-0292-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/ztd-0292-480.jpg 480w",
        "/media/vtd/ztd-0292-960.jpg 960w",
        "/media/vtd/ztd-0292-1600.jpg 1600w"
      ]
    }
  },
  "ztd-0297.jpg": {
    "width": 2400,
    "height": 1600,
    "sources": {
      "avif": [
        "/media/vtd/ztd-0297-480.avif 480w",
        "/media/vtd/ztd-0297-960.avif 960w",
        "/media/vtd/ztd-0297-1600.avif 1600w"
      ],
      "webp": [
        "/media/vtd/ztd-0297-480.webp 480w",
        "/media/vtd/ztd-0297-960.webp 960w",
        "/media/vtd/ztd-0297-1600.webp 1600w"
      ],
      "jpeg": [
        "/media/vtd/ztd-0297-480.jpg 480w",
        "/media/vtd/ztd-0297-960.jpg 960w",
        "/media/vtd/ztd-0297-1600.jpg 1600w"
      ]
    }
  }
} as const;
